import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useHistory } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import lapto from '../assets/img/lapto.png';
import '../styles/index.css';

export default function useWindowDimensions() {

    const hasWindow = typeof window !== 'undefined';

    function getWindowDimensions() {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
            width,
            height,
        };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        if (hasWindow) {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    return windowDimensions;
}

export const Login = () => {
    const history = useHistory();
    const { width } = useWindowDimensions();
    const [pedido, setPedido] = useState('');
    const [cliente, setCliente] = useState('');
    const [error, setError] = useState(false);
    const [errorCliente, setErrorCliente] = useState(false);
    const [labelInput] = useState("Ingresa como máximo 10 pedidos, separados por comas. ");
    const [labelCliente, setLabelCliente] = useState("");

    const BuscarPedido = () => {
        if(cliente !== '' && cliente.length>1){
            if(pedido !== '' && pedido.length>1 && pedido!==','){
                setError(false);
                history.push(`home/${pedido}/${cliente}`);
             }else{
                setError(true);
             }
        }else{
            setLabelCliente("Por favor ingresa un nombre de proveedor valido. ")
            setErrorCliente(true);
        }
        
        
    };

    return (
        <div>
            <div className="div-header-login" >
                <div>
                    <img className="logo" src={logo} alt="logo" />
                </div> 
                { (width < 450) ?
                 null : 
                 < div style={{ marginRight: '10%', fontSize: '14px', color: '#009A3F', fontWeight: 500 }} > Hacemos de la logística una ventaja competitiva... </div>}

            </div> 
            <div className="login  white calibri" id="login" >

                <form className="column form-login" >
                    <div className="center-text" > ¿Dónde está mi pedido? </div>
                    <TextField className="input-form"
                        id="cliente"
                        type="text"
                        label="Proveedor"
                        helperText={labelCliente}
                        error={errorCliente}
                        onChange={(e) => setCliente((e.target.value).replace(/ /g, ""))}
                         />
                    <TextField className="input-form"
                        id="pedidos"
                        type="text"
                        label="Ingresa tu código de seguimiento"
                        helperText={labelInput}
                        error={error}
                        onChange={(e) => setPedido((e.target.value).replace(/ /g, ""))}
                         />
                    <button className="btn-login"
                        type="button"
                        onClick={BuscarPedido} >
                        Buscar </button>
                </form>
                { (width < 768) ?
                 null : 
                <div className='divImagenLapto'> <img className="lapto" src={lapto} alt="lapto" /></div>}
            </div>
        </div>
    )
};